import { Image, Tooltip } from '@chakra-ui/react'

import helperIcon from '../../images/helper-icon.svg'

export const HelperTooltip = ({ label }: { label: string }) => {
  return (
    <Tooltip label={label} hasArrow placement="top">
      <Image src={helperIcon} alt="?" />
    </Tooltip>
  )
}
